document.documentElement.classList.add("asv-js");

function statusFor(button) {
  return button.closest(".asv-tools")?.querySelector(".asv-status");
}

function announce(button, message, kind) {
  const status = statusFor(button);
  if (!status) return;
  status.textContent = message;
  status.classList.remove("is-success", "is-error");
  status.classList.add(kind === "success" ? "is-success" : "is-error");
}

function fallbackCopy(text) {
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.append(area);
  area.select();
  const copied = document.execCommand("copy");
  area.remove();
  return copied;
}

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  if (!fallbackCopy(text)) throw new Error("Clipboard nicht verfügbar");
}

document.addEventListener("click", async (event) => {
  const copyButton = event.target.closest("[data-copy-target]");
  if (copyButton) {
    const target = document.querySelector(copyButton.dataset.copyTarget);
    if (!target) {
      announce(copyButton, "Kopieren fehlgeschlagen: Text nicht gefunden.", "error");
      return;
    }
    try {
      await copyText(target.textContent.trim());
      announce(copyButton, "In die Zwischenablage kopiert.", "success");
    } catch {
      announce(copyButton, "Kopieren fehlgeschlagen. Bitte Text manuell markieren.", "error");
    }
    return;
  }

  const printButton = event.target.closest("[data-print]");
  if (printButton) {
    announce(printButton, "Druckdialog wird geöffnet.", "success");
    window.print();
  }
});
